import { createSelector } from 'reselect';
import { getMetric } from '../../../Report/Report.selectors';
import ReportComponent from '../../../../utils/ReportComponent/ReportComponent';

const reportUtils = ReportComponent.utils;

const location = (state) => state.routingCompat;
const rows = (state) => state.statistics.data.rows;
const totals = (state) => state.statistics.data.totals;
const parameters = (state) => state.statistics.data.parameters;
const offers = (state) => state.offers.list;
const goals = (state) => state.goals.list;
const links = (state) => state.links.list;
const regions = (state) => state.regions.list;
const report = (state) => state.serverStorage.store.report;

export const getData = createSelector(
    rows,
    totals,
    parameters,
    offers,
    goals,
    links,
    regions,
    location,
    report,
    (rows = [], totals = {}, parameters = {}, _offers = [], _goals = [], _links = [], _regions = [], location = {}, report = {}) => {
        const urlParams = new URLSearchParams(location?.search);
        const urlMetrics = urlParams.get('metrics');
        
        const metrics = urlMetrics || report?.metrics || reportUtils.getDefStrMetric();
        let keysMetric = reportUtils.getKeysMetric(metrics);
        let data = [];

        if (Object.keys(totals).length) {
            data.push(keysMetric.map((key) => {
                if (key === 'GroupBy') {
                    return getMetric(key, totals[key], parameters, true);
                }
                return getMetric(key, totals[key], parameters, true);
            }));
        }

        rows.forEach((item) => {
            data.push(keysMetric.map((key) => {
                if (key === 'GroupBy') {
                    return getMetric(key, item[key], parameters);
                }
                return getMetric(key, item[key], parameters);
            }));
        });

        return data;
    }
);

export const getHeaderName = createSelector(
    parameters,
    location,
    report,
    (parameters = {}, location = {}) => {
        let list = [];

        let metrics = location?.query?.metrics || reportUtils.getDefStrMetric();
        let keysMetric = reportUtils.getKeysMetric(metrics);

        reportUtils.setKeyGroupBy(parameters.group_by);
        keysMetric.forEach((key) => {
            list.push(reportUtils.getTitleChain(key));
        });

        return list;
    }
);
